module.exports = __webpack_public_path__ + "img/icon-land-advanture.3159c443.svg";